import {UTCDate} from "@date-fns/utc";
import {differenceInSeconds} from "date-fns";

import {Alert} from "@/components/alert/Alert.tsx";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {isCheckPending} from "@/pages/checks/analysis/utils.ts";
import {getCheckCreatedMessage} from "@/pages/checks/utils.ts";

export interface ServicePendingBannerProps {
  state_is_up: boolean;
  created_at: string;
  checkType: MonitoringServiceType;
  forceInterval?: number;
}

export const ServicePendingBanner = ({
  state_is_up,
  checkType,
  forceInterval,
  created_at,
}: ServicePendingBannerProps) => {
  if (!isCheckPending(state_is_up, differenceInSeconds(new UTCDate(), created_at))) {
    return null;
  }
  const message = getCheckCreatedMessage(checkType, forceInterval);
  return (
    <Alert variant={"verification"} dismissible>
      {message}
    </Alert>
  );
};
